import React from "react";
import { forwardRef } from "react";
// material
import { useTheme } from "@mui/material/styles";
import { Fab, SxProps } from "@mui/material";
//
import { ButtonAnimate } from "../animate";
import { CustomTheme } from "../../types";

interface Props {
  children: React.ReactNode;
  sx?: SxProps;
  color:
    | "default"
    | "inherit"
    | "primary"
    | "secondary"
    | "info"
    | "success"
    | "warning"
    | "error";
}

const MFab = forwardRef<any, Props>(
  (
    { color = "primary", children, sx, ...other }: Props,
    ref: React.ForwardedRef<any>
  ) => {
    const theme = useTheme<CustomTheme>();

    if (
      color === "default" ||
      color === "inherit" ||
      color === "primary" ||
      color === "secondary"
    ) {
      return (
        <ButtonAnimate>
          <Fab ref={ref} color={color} sx={sx} {...other}>
            {children}
          </Fab>
        </ButtonAnimate>
      );
    }

    return (
      <ButtonAnimate>
        <Fab
          ref={ref}
          sx={{
            boxShadow: theme.customShadows[color],
            color: theme.palette[color].contrastText,
            bgcolor: theme.palette[color].main,
            "&:hover": {
              bgcolor: theme.palette[color].dark,
            },
            ...sx,
          }}
          {...other}
        >
          {children}
        </Fab>
      </ButtonAnimate>
    );
  }
);

export default MFab;
